import { currencyFormat } from "../utils/helpers";

export interface ITransactionBreakDown {
  amountDue?: number;
  agencyCode?: string;
  revenueCode?: string;
  oraAgencyRev?: string;
  transCode?: string;
  receipt?: string; 
  paymentRef? : string;
  amountPaid? : number;
  status?:string;
  webGuid?:string;
}

export const TransactionCard = (props: ITransactionBreakDown) => {
  return (
    <div className="bg-white rounded-lg p-3 my-3">
      <div className="flex justify-between ">
        <img src="/icons/transaction.svg" alt="" className="w-1/10" />
       {props.amountDue && !props.status ? <div className="text-white px-2 rounded bg-[#009600] font-semibold my-auto">
          {currencyFormat(props.amountDue)}
        </div>: <div className={`text-white px-2 rounded ${props.status=== "SUCCESS" ? "bg-[#009600]": "bg-rose-500"} font-semibold my-auto`}>
         {props.status}
        </div>}
      </div>
      <div className="mt-4 ">
        {props.agencyCode && <div className=" font-normal text-sm py-2 border-b border-gray-100 flex justify-between ">
          Agency code
          <span className="font-semibold">{props.agencyCode}</span>
        </div>}
        {props.revenueCode && <div className=" font-normal text-sm py-2 border-b border-gray-100 flex justify-between ">
          Revenue code
          <span className="font-semibold">{props.revenueCode}</span>
        </div>}
        {props.oraAgencyRev && <div className=" font-normal text-sm py-2 flex justify-between ">
          Ora Agency Rev
          <span className="font-semibold">{props.oraAgencyRev}</span>
        </div>}
        {props.amountPaid && <div className=" font-normal text-sm py-2 flex justify-between ">
          Amount Paid
          <span className="font-semibold"> {currencyFormat(props.amountPaid)}</span>
        </div>}
        {props.paymentRef && (<div className=" font-normal text-sm py-2 flex justify-between ">
        payment Ref 
          <span className="font-semibold">{props.paymentRef}</span>
        </div>)}
       {props.transCode && (<div className=" font-normal text-sm py-2 flex justify-between ">
         Transacrion code
          <span className="font-semibold">{props.transCode}</span>
        </div>)}
        {props.webGuid && (<div className=" font-normal text-sm py-2 flex justify-between ">
         Web Guid
          <span className="font-semibold">{props.webGuid}</span>
        </div>)}

        { props.receipt && (  <a href={props.receipt} className="bg-blue-400 text-white px-3 mx-auto mt-3 flex items-center justify-center py-2" target={"_blank"}>Download receipt</a>)     }     
       </div>
    </div>
  );
};
